import PropTypes from 'prop-types';

// Shared shape for the personalization form values and their persisted
// cookieDataDump counterpart. All fields are optional — individual steps only
// touch a subset, but they all read from this same data object.
// A named export on purpose: this file is the home for the form's shared
// PropTypes shapes, so more will join personalizationDataShape here.
// eslint-disable-next-line import/prefer-default-export
export const personalizationDataShape = PropTypes.shape({
  drupal_uuid: PropTypes.string,
  email: PropTypes.string,
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  my_favorites_page: PropTypes.string,
  field_favorites_page_message: PropTypes.string,
  residentSelection: PropTypes.string,
  person2_drupal_uuid: PropTypes.string,
  person2_first_name: PropTypes.string,
  person2_last_name: PropTypes.string,
  person2_email: PropTypes.string,
});
